import {
  type GenerateStyle,
  type FullToken,
  genComponentStyleHook,
} from "antd/es/theme/internal";
import { datepickerPrefixCls } from "@/base/components/datepicker/Datepicker.component";
import { ICON_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"DatePicker">> = (token: any) => {
  const {
    controlHeight,
    colorIcon,
    iconSize,
    controlHeightLG,
    controlHeightSM,
  } = token;
  return {
    [`.${datepickerPrefixCls}`]: {
      minHeight: controlHeight,

      [`&.${datepickerPrefixCls}-large`]: {
        minHeight: controlHeightLG,
      },

      [`&.${datepickerPrefixCls}-small`]: {
        minHeight: controlHeightSM,
      },

      [`&.${datepickerPrefixCls}-range input`]: {
        textAlign: "center",
      },

      [`.${datepickerPrefixCls}-range-separator .${ICON_PREFIX}`]: {
        color: `${colorIcon}`,
      },

      [`.${ICON_PREFIX}`]: {
        color: `${colorIcon}`,
        fontSize: iconSize,
      },
    },
  };
};

export const useDatepickerStyle = genComponentStyleHook(
  ["DatePicker", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
